export { default, getServerSideProps } from '../articles/index.page';